import {
  Avatar,
  AvatarGroup,
  Badge,
  Box,
  IconButton,
  Tooltip,
  useTheme,
  Typography,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EditIcon from '@mui/icons-material/Edit';
import ExoDialog from '../ExoDialog';
import AddMembers from '../../special/AddMembers';
import { useState } from 'react';
import { API_POST, DBRequest, useConfig } from '../../../api/api';
import { getInitials } from '../ExoAvatar';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
export const ProjectUserStack = ({
  workPackage,
  users,
  className,
  onChange,
  editmode,
  projectId,
  api,
  changeApi,
  label,
  displayCount = 2,
  noLabel,
  size,
  noEmptyIcon,
  component,
  project,
  supervisor,
  showPermissions,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();
  const config = useConfig();
  const [open, setOpen] = useState(false);

  function handleAddMember(ids, newMembers, membersWithPermissions) {
    const data = supervisor
      ? {
          mode: 'sync',
          members: (membersWithPermissions || newMembers).map((m) => ({
            id: m.id,
            canWrite: m.canWrite || false,
          })),
        }
      : {
          relations: ids,
          mode: 'sync',
          relationType: 'users',
        };
    DBRequest({
      config,
      path: changeApi || `work-packages/${workPackage.id}/members`,
      onResponse: (res) =>
        handleResponse(res, newMembers, membersWithPermissions),
      method: API_POST(data),
    });
  }

  function handleResponse(data, newMembers, membersWithPermissions) {
    setOpen(false);
    if (membersWithPermissions) {
      const permMap = {};
      membersWithPermissions.forEach((m) => {
        permMap[m.id] = m.canWrite || false;
      });
      const updatedMembers = newMembers.map((m) => ({
        ...m,
        canWrite:
          m.id === supervisor?.id ? true : permMap[m.id] || false,
      }));
      onChange(data.data, updatedMembers);
    } else {
      onChange(data.data, newMembers);
    }
  }

  const renderAvatar = (user) => {
    const avatar = (
      <Avatar
        alt={`${user.firstName} ${user.lastName}`}
        src={user.picture && user.picture.thumbnailUrl}
        size={size || '40px'}
      >
        {getInitials(`${user.firstName} ${user.lastName}`)}
      </Avatar>
    );

    if (showPermissions && user.canWrite) {
      return (
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                backgroundColor: colors.success,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <EditIcon sx={{ fontSize: 10, color: '#fff' }} />
            </Box>
          }
        >
          {avatar}
        </Badge>
      );
    }

    return avatar;
  };

  return (
    <Box
      className="no-nav"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      sx={{
        '& .MuiAvatar-root': {
          borderColor: colors.selected,
          borderWidth: '1px',
          backgroundColor: colors.glassSolid,
          color: colors.grey[900],
        },
      }}
    >
      {!noLabel && (
        <Typography variant="h6" className="uppercase pt-2">
          {label || t('Member')}
        </Typography>
      )}
      {users && (
        <AvatarGroup
          className={`${className} ${editmode ? 'cursor-pointer' : ''}`}
          total={editmode ? users.length + 1 : users.length}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          }}
          sx={{
            '& .MuiAvatar-root': {
              borderColor: colors.selected,
              borderWidth: '1px',
              backgroundColor: colors.glassSolid,
              color: colors.grey[900],
            },
          }}
        >
          {users.map(
            (user, index) =>
              index < displayCount && (
                <Tooltip
                  title={`${user.firstName} ${user.lastName}`}
                  key={user.id}
                >
                  {renderAvatar(user)}
                </Tooltip>
              ),
          )}
          {editmode && (
            <Tooltip title={t(`Edit Team`)}>
              <Avatar size={size || '40px'}>
                <GroupAddIcon />
              </Avatar>
            </Tooltip>
          )}
        </AvatarGroup>
      )}
      <ExoDialog open={open && editmode} onClose={() => setOpen(false)}>
        <AddMembers
          api={api || `projects/${projectId}/team`}
          className="mx-auto"
          onClose={() => setOpen(false)}
          members={users || []}
          onSubmit={handleAddMember}
          component={component}
          project={project}
          showPermissions={!!supervisor && showPermissions}
          supervisorId={supervisor?.id}
        />
      </ExoDialog>
    </Box>
  );
};
